import { styled } from '@mui/material/styles';
import {
  Box, Tabs, Tab, Typography,
} from '@mui/material';

import colors from '../../../../../styles/colors';
import { TONE_COLORS } from '../CampaignTable/styles';

const Eyebrow = styled(Typography)({
  fontSize: 11,
  letterSpacing: 1,
  textTransform: 'uppercase',
  color: colors.shades.gamma10,
  marginBottom: 8,
});

const SnapshotLabel = styled(Typography)({});
SnapshotLabel.defaultProps = { variant: 'body2', color: 'text.secondary' };

const SnapshotValue = styled(Typography)({
  wordBreak: 'break-word',
});
SnapshotValue.defaultProps = { variant: 'body2' };

const StatLabel = styled(Typography)({
  display: 'block',
  lineHeight: 1.4,
  letterSpacing: 1,
});
StatLabel.defaultProps = { variant: 'overline', color: 'text.secondary' };

const MessageBody = styled(Box)({
  padding: '12px 14px',
  background: colors.base.gamma,
  borderRadius: 4,
  fontSize: 13,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
});

const MessageImage = styled('img')({
  display: 'block',
  maxWidth: 220,
  maxHeight: 220,
  marginBottom: 12,
  borderRadius: 4,
  border: `1px solid ${colors.shades.gamma1}`,
});

const SubTabs = styled(Tabs)({
  minHeight: 40,
  borderBottom: `1px solid ${colors.shades.gamma1}`,
  marginBottom: 16,
  '& .MuiTabs-indicator': { backgroundColor: colors.base.beta, height: 2 },
});

const SubTab = styled(Tab)({
  textTransform: 'none',
  minHeight: 40,
  padding: '8px 12px',
  fontSize: 13,
  color: colors.shades.gamma10,
  '&.Mui-selected': { color: colors.base.beta },
});

const StatCardsRow = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: 12,
  marginBottom: 16,
});

const StatCard = styled(Box)({
  padding: '12px 14px',
  background: colors.base.gamma,
  borderRadius: 6,
});

const StatValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'tone',
})(({ tone }) => ({
  fontSize: 22,
  fontWeight: 600,
  color: TONE_COLORS[tone] ?? colors.base.beta,
}));

const SnapshotTable = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'minmax(110px, 140px) 1fr',
  rowGap: 10,
  columnGap: 16,
  padding: '4px 0',
});

const FailedList = styled(Box)({
  maxHeight: 360,
  overflowY: 'auto',
  border: `1px solid ${colors.shades.gamma1}`,
  borderRadius: 6,
});

const FailedRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 14px',
  borderBottom: `1px solid ${colors.shades.gamma1}`,
  '&:last-of-type': { borderBottom: 'none' },
});

export {
  Eyebrow,
  SnapshotLabel,
  SnapshotValue,
  StatLabel,
  MessageBody,
  MessageImage,
  SubTabs,
  SubTab,
  StatCardsRow,
  StatCard,
  StatValue,
  SnapshotTable,
  FailedList,
  FailedRow,
};
